export enum EMPLOYEE_ROLES {
  ASSOCIATE = '1',
  MANAGER = '2',
  ADMIN = '3',
  OWNER = '4',
}
